import { render } from "./Estado.vue?vue&type=template&id=59fae47f"
import script from "./Estado.vue?vue&type=script&lang=js"
export * from "./Estado.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__